import React from 'react';
import { Box, Button, Text } from '@wix/design-system';
import { useModalystInstall } from '../hooks';
import { generateToken } from '../utils';
const referral = 'wix-aichat-explore';
const action = 'explore_on_modalyst';
export const ExploreOnModalyst = _ref => {
  let {
    data: {
      metaSiteId
    },
    context: {
      onWidgetAction
    }
  } = _ref;
  const {
    startInstall
  } = useModalystInstall({
    referral,
    usePopup: false
  });
  const handleActionClick = () => {
    const modalystToken = generateToken(10);
    onWidgetAction(EXPLORE_ON_MODALYST, {
      action
    });
    startInstall({
      metaSiteId,
      modalystToken
    });
  };
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: 2
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, "Clicking the button below will open the Modalyst app on a product Marketplace. I will also ensure that a Modalyst app is installed on your Wix site, that an account is created for you in Modalyst and your current Wix site is connected to Modalyst."), /*#__PURE__*/React.createElement(Button, {
    size: "small",
    priority: "secondary",
    onClick: handleActionClick,
    fullWidth: true
  }, "Explore products on Modalyst"));
};
export const EXPLORE_ON_MODALYST = 'EXPLORE_ON_MODALYST';
//# sourceMappingURL=ExploreOnModalyst.js.map